<template>
  <div>
    <TemplatePreview />
  </div>
</template>

<script>
import TemplatePreview from '@/components/TemplatePreview'
import { mapState, mapGetters } from 'vuex'

export default {
  components: {
    TemplatePreview
  },
  data () {
    return {
      templateBuilderQuery: this.$helpers.getTemplateBuilderQuery(this.$route)
    }
  },
  computed: {
    ...mapState({
      accountId: state => state.templateBuilder.accountId
    }),
    ...mapGetters({
      activeType: 'getActiveType'
    })
  },
  watch: {
    accountId () {
      this.init()
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      if (this.accountId) {
        if (this.activeType === 'saved') {
          this.$store.dispatch('setTemplateOnPreview', { ...this.templateBuilderQuery })
        } else if (this.activeType === 'prebuilt') {
          this.$store.dispatch('setPrebuiltTemplateOnPreview', { ...this.templateBuilderQuery })
        }
      }
    }
  }
}
</script>
